module.exports = __webpack_public_path__ + "img/reputation-empty.69672de2.png";